import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  input,
  Input,
  OnInit,
  Output,
  ViewChild,
  signal,
} from '@angular/core';

import { TagModel } from '@core/models/tag.model';
import { PopupTagComponent } from '@ux/components/select-popup/popup-tag/popup-tag.component';
import { TagComponent } from '@ux/components/tag/tag.component';
import { NgClickOutsideDelayOutsideDirective } from 'ng-click-outside2';

@Component({
  selector: 'app-task-view-tag',
  templateUrl: './task-view-tag.component.html',
  styleUrls: ['./task-view-tag.component.less'],
  imports: [TagComponent, PopupTagComponent, NgClickOutsideDelayOutsideDirective],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaskViewTagComponent implements OnInit {
  private _tagList: TagModel[] = [];
  private _tags: string[] = [];
  private availableSpace: number = 0;

  protected popupTopPosition = signal<number>(0);

  @Output() onChangeTags: EventEmitter<TagModel> = new EventEmitter();

  @ViewChild('addButton', { static: false, read: ElementRef }) addButton: ElementRef<HTMLElement>;
  @ViewChild('popupTag', { static: false, read: ElementRef }) popupTag: ElementRef<HTMLElement>;

  protected readonly projectId = input<string>();

  @Input()
  set tags(value: string[]) {
    this._tags = value;
  }

  get tags(): string[] {
    return this._tags;
  }

  @Input()
  set availabletagList(value: TagModel[]) {
    this._tagList = value;
  }

  get availabletagList(): TagModel[] {
    return this._tagList;
  }

  isOpen = false;

  ngOnInit() {}

  onSelect(event: TagModel) {
    this.onChangeTags.emit(event);
  }

  onOpen(event) {
    event.stopPropagation();
    event.preventDefault();

    this.availableSpace = window.innerHeight - this.addButton.nativeElement.getBoundingClientRect().bottom;
    this.isOpen = true;

    setTimeout(() => this.updatePopupPosition());
  }

  private updatePopupPosition() {
    if (!this.popupTag) {
      return;
    }

    // Получаем высоту popup
    const popupHeight = this.popupTag.nativeElement.offsetHeight;
    const spaceNeeded = popupHeight + 10; // 10px для отступа

    // Используем предварительно вычисленное пространство
    let top: number;
    if (this.availableSpace >= spaceNeeded) {
      top = this.addButton.nativeElement.offsetHeight + 10;
    } else {
      top = -popupHeight - 10;
    }

    // Обновляем сигнал позиционирования
    this.popupTopPosition.set(top);
  }

  onClose() {
    this.isOpen = false;
    this.availableSpace = 0;
  }
}
